const MAX_SLUG_LENGTH = 80

/**
 * Client-side preview of the slug a title would produce server-side. The
 * backend re-normalizes whatever value is sent, so this is purely for the
 * editor's auto-sync UX. Must stay in sync with the server-side `slugify`
 * helper in `core-modules/_legacy/services/changelog-entries/helpers/slugify`.
 */
export function slugify(input: string): string {
  const normalized = input
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/['’`]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

  if (normalized.length === 0) {
    return ''
  }

  return normalized.slice(0, MAX_SLUG_LENGTH).replace(/-+$/g, '')
}
